import React from 'react';
import PropTypes from 'prop-types';

/**
 * Svg icon component
 *
 * @param {string} className Addition CSS classes
 * @param {string} size Icon size
 * @param {string} iconName Icon name
 * @constructor
 */
const Svg = ({ className = '', size, iconName }) => (
    <svg className={`ui-icon ui-icon_size${size} ${className}`}>
        <use xlinkHref={`img/icons.svg#icon-${iconName}`} />
    </svg>
);

Svg.propTypes = {
    iconName: PropTypes.string.isRequired,
    size: PropTypes.string,
    className: PropTypes.string
};

export default Svg;



// WEBPACK FOOTER //
// ./src/js/modules/Svg/index.js